import "./App.css";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import IndexPage from "./view";
import ChildrenPrivacyPage from "./view/childrenPrivacy";
import ChildrenManualPage from "./view/childrenManual";
import PrivacyPage from "./view/privacy";
import ManualPage from "./view/manual";
import DetailPage from "./view/detail";
import DescriptionPage from "./view/description";
import TongueDescription from "./view/tongueDescription";
import TongueGuide from "./view/tongueGuide";
import VipServicePage from "./view/vipService";
import AutomaticRenewalPage from "./view/automaticRenewal";
import RecognitionDescription from "./view/recognitionDescription";

const router = createBrowserRouter([
    {
        path: "*",
        element: <IndexPage />,
    },
    {
        path: "/children-privacy",
        element: <ChildrenPrivacyPage />,
    },
    {
        path: "/children-manual",
        element: <ChildrenManualPage />,
    },
    {
        path: "/privacy",
        element: <PrivacyPage />,
    },
    {
        path: "/manual",
        element: <ManualPage />,
    },
    {
        path: "/vip-service",
        element: <VipServicePage />,
    },
    {
        path: "/automatic-renewal",
        element: <AutomaticRenewalPage />,
    },
    {
        path: "/description",
        element: <DescriptionPage />,
    },
    {
        path: "/tongue-description",
        element: <TongueDescription />,
    },
    {
        path: "/recognition-description",
        element: <RecognitionDescription />,
    },
    {
        path: "/tongue-guide",
        element: <TongueGuide />,
    },
    {
        path: "/detail/:id",
        element: <DetailPage />,
    },
    {
        path: "/detail/:dev/:id",
        element: <DetailPage />,
    },
]);

function App() {
    return <RouterProvider router={router} />;
}

export default App;
